// extracted by mini-css-extract-plugin
export default {"orbit":"style_orbit__1L0So","sub_orbit":"style_sub_orbit__sDFGk","orbit_div":"style_orbit_div__YmT2y"};